// @flow
import * as React from "react"
import { css } from "react-emotion/macro"
import { ImageFit } from "../ImageFit/index"

export type tPageMarquee = {
  image: {
    url: string,
    alt: string,
  },
}

export type tPageMarqueeState = {}

export class PageMarquee extends React.Component<
  tPageMarquee,
  tPageMarqueeState,
> {
  render() {
    return this.props.image ? (
      <ImageFit
        src={this.props.image.url}
        alt={this.props.image.alt}
        className={css`
          width: 100%;
          height: 400px;
          margin-top: 0;
        `}
      />
    ) : null
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/PageMarquee/index.js